import React from 'react'
import {
  Wrapper,
  Title,
  BoxesWrapper,
  Box,
  BoxTitle,
  BoxDescription,
  Image,
} from './BottomBoxes.styled'
import { Trans } from 'react-i18next'
import platformsImage from 'Assets/images/platforms.webp'

export type BoxType = {
  title: string
  description: string
}

export type BottomBoxesProps = {
  title: string
  boxes: Array<BoxType>
  BM?: boolean
}

export const BottomBoxes = ({ title, boxes, BM }: BottomBoxesProps) => {
  return (
    <Wrapper>
      <Title>
        <Trans defaults={title} components={{ br: <br /> }} />
      </Title>
      {!BM && <Image src={platformsImage} />}
      <BoxesWrapper>
        {boxes.map((box, index) => (
          <Box key={index}>
            <BoxTitle>{box.title}</BoxTitle>
            <BoxDescription>{box.description}</BoxDescription>
          </Box>
        ))}
      </BoxesWrapper>
    </Wrapper>
  )
}
